import {Button, Layout, Spacer, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {t} from '../../../localization';
import {useScheduleDataContext, useSnacksActions} from '../../../services';

export const ConfirmEditPanel: React.FC = () => {
  const context = useScheduleDataContext();

  // Snack
  const {add: addSnack} = useSnacksActions();

  const handleConfirmTasks = useCallback(() => {
    return context
      .commitEdit()
      .then(() => {
        // Success!
        addSnack({
          text: t('screens.schedule.edit.success', {
            tasks: context.droppedTasks.length,
          }),
          status: 'Success',
        });
      })
      .catch(() => {
        // Fail!
        addSnack({text: t('screens.schedule.edit.fail'), status: 'Error'});
      });
  }, [addSnack, context]);

  return context.droppedTasks.length > 0 ? (
    <Layout
      backgroundColor="background_mono_primary"
      horizontal
      borderTopColor={'border_mono_15'}
      borderTopWidth="1"
      borderTopStyle="solid"
      paddingVertical="20"
      paddingHorizontal={'20'}>
      {/** Edit status */}
      <Layout flex={1} align="center">
        <Text>
          {t('screens.schedule.edit.description', {
            tasks: context.droppedTasks.length,
          })}
        </Text>
      </Layout>
      <Spacer width="20" />
      {/** Buttons */}
      <Layout horizontal alignSelf="flex-start">
        <Button
          title={t('general.cancel')}
          kind="Secondary"
          onPress={context.cancelEdit}
        />
        <Spacer width="8" />
        <Button
          title={t('general.confirm')}
          kind="Primary"
          onPress={handleConfirmTasks}
        />
      </Layout>
    </Layout>
  ) : null;
};
